import { requestTool } from "../tools";

const CONTROLLER_URL = "/api/movie";

const getAll = () => requestTool.
    getRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL);

const get = (id) => requestTool.
    getRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "/" + id);

const add = (item) => requestTool.
    postFormRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL, item);

const should = (item) => requestTool.
    postRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "/should", item);

const addWatchList = (item) => requestTool.
    postRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "/AddWatchList", item);

const update = (item) => requestTool.
    putRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL, item);

const remove = (id) => requestTool.
    deleteRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + id);

const search = (key) => requestTool.
    getRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "?_key=" + key);

const paginate = (data) => requestTool.
    postRequest(process.env.REACT_APP_API_URL + CONTROLLER_URL + "/paginate", data);

export const movieService = {
    getAll,
    add, 
    update, 
    remove, 
    search, 
    paginate, 
    get,
    should,
    addWatchList
};

export default movieService;